module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-card"
  }, [_c('box-helper'), _vm._v(" "), (_vm.heading) ? _c('div', {
    staticClass: "table-title"
  }, [(_vm.icon) ? _c('i', {
    class: 'fas fa-fw fa-' + _vm.icon
  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.heading) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-data-table', {
    class: _vm.customClass,
    attrs: {
      "search": _vm.search,
      "headers": _vm.headers,
      "items": _vm.items,
      "items-per-page": 50
    }
  }, [_c('no-data', {
    attrs: {
      "slot": "no-data"
    },
    slot: "no-data"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer.page-text"
    },
    slot: "footer.page-text"
  }, [_vm._v("\n            Footer text?\n        ")])], 1) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "box-date-range"
  }, [_vm._m(0), _vm._v(" "), _c('datepicker', {
    staticClass: "date-picker",
    attrs: {
      "language": _vm.datepickerLocale,
      "placeholder": "Startdato"
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('datepicker', {
    staticClass: "date-picker",
    attrs: {
      "language": _vm.datepickerLocale,
      "placeholder": "Slutdato"
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('i', {
    staticClass: "fal fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "to"
  }, [_c('i', {
    staticClass: "fal fa-chevron-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30dee4b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/TableCard.vue
// module id = 838
// module chunks = 0